import { Component, OnInit, Input } from '@angular/core';
import { PlanStatusInputModel } from 'src/app/core/model/input/plan-status-input-model';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { CalendarShared } from '../../general/shared/calendar-shared';
import { TutorialShared } from '../../general/shared/tutorial-shared';
import { TutorialService } from 'src/app/data/repository/tutorial-repository/tutorial.service';

@Component({
  selector: 'app-plan-status',
  templateUrl: './plan-status.component.html',
  styleUrls: ['./plan-status.component.scss'],
})
export class PlanStatusComponent implements OnInit {
  @Input() input: PlanStatusInputModel;
  private _dataIsReady = false;
  @Input() set dataIsReady(value: boolean) {
    this._dataIsReady = value;
    if (value) {
      setTimeout(() => {
        this.initial();
      }, 300);
    }
  }
  get dataIsReady(): boolean {
    return this._dataIsReady;
  }

  durationEndTime: Date;

  constructor(
    private planService: PlanService,
    private calendarShared: CalendarShared,
    private tutorialShared: TutorialShared,
    private tutorialService: TutorialService
  ) {
    this.durationEndTime = new Date(
      new Date().setHours(new Date().getHours() + 5)
    );
  }

  ngOnInit() {}

  initial() {
    if (this.dataIsReady && this.input?.type === 'generate') {
      setTimeout(() => {
        this.tutorialShared.noDietBox = document.getElementById('no-diet-box');
        this.tutorialService.checkNoDietTutorial();
      }, 10);
    }
  }

  select() {
    if (this.input?.type === 'generate') {
      // this.planService.goToGenerate();
      if (this.input?.needReturn) {
        this.planService.goBack();
        setTimeout(() => {
          this.planService.goToSecondTabPlans();
        }, 500);
      } else {
        this.planService.goToSecondTabPlans();
      }
    } else if (this.input?.type === 'before') {
      this.planService.goToSecondTabMyPlan();
      // this.planService.goToPlanOverview();
    } else if (this.input?.type === 'cheatDay') {
      this.planService.goToSecondTabMyPlan();
      // this.planService.goToPlanOverview();
    } else if (this.input?.type === 'hasDiet') {
      this.calendarShared.selectedDate = new Date(
        new Date().setHours(0, 0, 1, 0)
      );
      this.calendarShared.closeCalendar();
    } else if (this.input?.type === 'diet') {
      this.planService.goToSecondTabMyPlan();
      // this.planService.goToPlanOverview();
    } else if (this.input?.type === 'daily') {
      this.planService.goToSecondTabMyPlan();
      // this.planService.goToPlanOverview();
    } else if (this.input?.type === 'hourly') {
      this.planService.goToSecondTabMyPlan();
      // this.planService.goToPlanOverview();
    }
  }
}
